import { FC, useState } from 'react'
import { Container } from './styled'
import { PlayIcon } from './play-icon'

type Props = {
  id: string
  poster: string
  isCollapsed?: boolean
  onPlay?: () => void
}

export const Video: FC<Props> = ({
  id,
  poster,
  onPlay,
  isCollapsed = false,
}) => {
  const [isVisible, setVisible] = useState(false)

  const handleClick = () => {
    setVisible(true)

    if (onPlay) {
      onPlay()
    }
  }

  return (
    <Container $isCollapsed={isCollapsed}>
      {isVisible ? (
        <iframe
          src={`https://www.youtube.com/embed/${id}?autoplay=true`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ) : (
        <button onClick={handleClick}>
          <img src={poster} alt="" />
          <PlayIcon />
        </button>
      )}
    </Container>
  )
}
